import apiService from '../../../../apiService'
import Notification from '../../../../../../../../../resources/js/notification'

const DEFAULT_VALUE = {}

export default {
  namespaced: true,
  state: {
    statistic: DEFAULT_VALUE,
    loading: false
  },
  mutations: {
    setStatistic (state, payload) {
      state.statistic = payload
    }
  },
  actions: {
    fetch ({ state, commit }, domain) {
      state.loading = true

      apiService.getTrafficCommon(domain)
        .then(response => {
          commit('setStatistic', response.data.statistic)
          state.loading = false
        })
        .catch(() => {
          commit('setStatistic', DEFAULT_VALUE)
          state.loading = false

          Notification.notifyError({
            title: 'Ошибка',
            content: 'Не удалось загрузить информацию по количеству страниц в индексе и наличии в Yandex каталоге.'
          })
        })
    }
  }
}
